"use strict";
var Ajaxinate = function(t) {
    var e = t || {};
    this.settings = Object.assign({
        pagination: "#pagination-wrapper",
        method: "scroll",
        container: "#product-grid",
        offset: 1000,//11700,
        loadingText: "טוען...",
         async: true,
        callback: null
    }, e),
    this.addScrollListeners = this.addScrollListeners.bind(this),
    this.addClickListener = this.addClickListener.bind(this),
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this),
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this),
    this.destroy = this.destroy.bind(this),
    this.containerElement = document.querySelector(this.settings.container),
    this.paginationElement = document.querySelector(this.settings.pagination),
    this.initialize()
};
Ajaxinate.prototype.initialize = function() {
    this.containerElement && {
        click: this.addClickListener,
        scroll: this.addScrollListeners
    }[this.settings.method]()
}
,
Ajaxinate.prototype.addScrollListeners = function() {
    this.paginationElement && (document.addEventListener("scroll", this.checkIfPaginationInView),
    window.addEventListener("resize", this.checkIfPaginationInView),
    window.addEventListener("orientationchange", this.checkIfPaginationInView))
}
,
Ajaxinate.prototype.addClickListener = function() {
    this.paginationElement && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.clickActive = !0,
    null !== this.nextPageLinkElement && this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks))
}
,
Ajaxinate.prototype.stopMultipleClicks = function(t) {
    t.preventDefault(),
    this.clickActive && (this.nextPageLinkElement.innerHTML = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.clickActive = !1,
    this.loadMore())
}
,
Ajaxinate.prototype.checkIfPaginationInView = function() {
    var t = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
    e = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
    t <= window.innerHeight && e >= 0 && (this.nextPageLinkElement = this.paginationElement.querySelector("a"),
    this.removeScrollListener(),
    this.nextPageLinkElement && (this.nextPageLinkElement.innerHTML = this.settings.loadingText,
    this.nextPageUrl = this.nextPageLinkElement.href,
    this.loadMore()))
}
,
  Ajaxinate.prototype.loadMore = async function() {
    try {
        const response = await fetch(this.nextPageUrl);
        
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(await response.text(), 'text/html');
        
        const containerContent = doc.querySelectorAll(this.settings.container)[0];
        const paginationContent = doc.querySelectorAll(this.settings.pagination)[0];
        
        this.containerElement.insertAdjacentHTML("beforeend", containerContent.innerHTML);
        
        // var api = new Yotpo.API(yotpo);
        // api.refreshWidgets();
        if ( window.sliderProductCard ) {
            window.sliderProductCard();
        }
        
        
        if (!paginationContent) {
            document.querySelector('#pagination-wrapper').remove();
        } else {
            this.paginationElement.innerHTML = paginationContent.innerHTML;
            
            if (this.settings.callback && typeof this.settings.callback === 'function') {
                this.settings.callback(doc);
            }
            
            this.initialize();
        }
    } catch (error) {
        console.error('Ошибка при загрузке:', error);
    }
}

,
Ajaxinate.prototype.removeClickListener = function() {
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks)
}
,
Ajaxinate.prototype.removeScrollListener = function() {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
    window.removeEventListener("resize", this.checkIfPaginationInView),
    window.removeEventListener("orientationchange", this.checkIfPaginationInView)
}
,
Ajaxinate.prototype.destroy = function() {
    return {
        click: this.removeClickListener,
        scroll: this.removeScrollListener
    }[this.settings.method](),
    this
}
;
